import { isValidBIC } from 'ibantools';
import { registerDecorator } from 'class-validator';
export function normalizeBic(value) {
    return value.replace(/\s+/g, '').toUpperCase();
}
export function isBicValid(value) {
    return isValidBIC(normalizeBic(value));
}
export function IsValidBic(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isValidBic',
            target: object.constructor,
            propertyName,
            options: { message: 'BIC is not valid', ...validationOptions },
            validator: {
                validate(value) {
                    return typeof value === 'string' && isBicValid(value);
                },
            },
        });
    };
}
//# sourceMappingURL=bic.js.map